import ListItem from "@mui/material/ListItem";
import { NotificationData } from "../../models/notification.model";
import styles from "./Notifications.module.scss";
import notificationNoRead from "../../assets/icons/notification-noread.svg";
import notificationReaded from "../../assets/icons/notification-readed.svg";
import remove from "../../assets/icons/remove.svg";
import { Tooltip } from "@mui/material";

interface Props {
  item: NotificationData;
  handleOnClick: (item: NotificationData) => void;
  handleOnRemove: (id: number) => void;
}

const NotificationItem: React.FC<Props> = ({
  item,
  handleOnClick,
  handleOnRemove,
}) => {
  return (
    <ListItem>
      <div className={styles.notificationItem}>
        <div className={styles.info} onClick={() => handleOnClick(item)}>
          <div className={styles.icon}>
            {item.isReaded ? (
              <img src={notificationReaded} alt="readed" />
            ) : (
              <img src={notificationNoRead} alt="noread" />
            )}
          </div>
          <Tooltip title={item.title}>
            <div
              className={
                styles.title +
                " " +
                (item.isReaded ? styles.readed : styles.noread)
              }
            >
              {item.title}
            </div>
          </Tooltip>
        </div>
        <div
          className={styles.delete}
          onClick={(e) => {
            e.stopPropagation();
            handleOnRemove(item.id);
          }}
        >
          <img src={remove} alt="remove" />
        </div>
      </div>
    </ListItem>
  );
};

export default NotificationItem;
